import { render, staticRenderFns } from "./agree_list.vue?vue&type=template&id=39bf0698&scoped=true"
import script from "./agree_list.vue?vue&type=script&lang=js"
export * from "./agree_list.vue?vue&type=script&lang=js"
import style0 from "./agree_list.vue?vue&type=style&index=0&id=39bf0698&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bf0698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39bf0698')) {
      api.createRecord('39bf0698', component.options)
    } else {
      api.reload('39bf0698', component.options)
    }
    module.hot.accept("./agree_list.vue?vue&type=template&id=39bf0698&scoped=true", function () {
      api.rerender('39bf0698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_activity/components/agree_list.vue"
export default component.exports